import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const BUSS_DATA = {
    // type 1：文字  2：数字中划线  3：缺货
    // money 金额   doubi 充值抖币  id  商品编号
  
  
    // 新的编号  5-26
    kuaishou: [
        { money: 7, doubi: 60, id: 15411905 },
        { money: 33, doubi: 300, id: 12743326 },
        { money: 55, doubi: 500, id: 15312906 },
        { money: 107, doubi: 980, id: 10292377,},
        { money: 432, doubi: 3980, id: 15312907 },
        { money: 723, doubi: 6660, id: 15312908 },
        { money: 965, doubi: 8880, id: 15312909 },
        { money: 2052, doubi: 18880, id: 15312910,},
        { money: 3259, doubi: 30000, id: 14943947},
        { money: 5429, doubi: 50000, id: 11178870 },
        { money: 10865, doubi: 99990, id: 15312911 },
        { money: 21729, doubi: 199990, id: 15312912,},



        // { money: 107, doubi: 980, id: 10292377, type: 1, tips: '热销' },
        // { money: 7, doubi: 60, id: 15411905 },
        // { money: 33, doubi: 300, id: 12743326 },
        // { money: 324, doubi: 2980, id: 16640327 },
        // { money: 564, doubi: 5180, id: 13276422, type: 1, tips: '热销'  },
        // // { money: 1413, doubi: 13140, id: 15014310 },
        // { money: 1737, doubi: 15980, id: 11301405 },
        // { money: 3261, doubi: 30000, id: 14943947},
        // { money: 5435, doubi: 50000, id: 11178870 },
        // { money: 10799, doubi: 100000, id: 14143430, type: 1, tips: '限时优惠'},
    ],
};
const store = new Vuex.Store({
    state: {
        count: 0,
        title: '',
        dyDiscernType: 0,  // 抖音识别接口渠道   0：抖音官方   1：同行
        websiteInfo: {
            defaultData: {
                orderType: '20',
                skuDb: BUSS_DATA.kuaishou,
            },
            // 'm.bxsvip.cn': {
            //     orderType: '20',
            //     skuDb: BUSS_DATA.kuaishou,
            //     disabledAndroid: false,
            //     hasPaySys: 'N', // 没有支付系统权限(安卓)
            //     onlineChat: 'https://work.weixin.qq.com/kfid/kfca394c4b30b34224f',
            //     weChat: 'https://work.weixin.qq.com/ca/cawcdebe21de070a89',
            // },
            // 'vip.bxsvip.cn': {
            //     orderType: '21',
            //     skuDb: BUSS_DATA.kuaishou,
            //     disabledAndroid: true,
            //     hasPaySys: 'Y', // 没有支付系统权限(安卓)
            //     onlineChat: 'https://work.weixin.qq.com/kfid/kfca394c4b30b34224f',
            //     weChat: 'https://work.weixin.qq.com/ca/cawcdebe21de070a89',
            // },
            'bb.bxsvip.com': {
                orderType: '30',
                skuDb: BUSS_DATA.kuaishou,
                disabledAndroid: false,
                hasPaySys: 'N', // 没有支付系统权限(安卓)
                onlineChat: 'https://work.weixin.qq.com/kfid/kfc229023d1b6473e1a',
                weChat: 'https://work.weixin.qq.com/ca/cawcdebe21de070a89',
            },
            'wap.ksmvp.cn': {
                orderType: '43',
                disabledAndroid: false,
                hasPaySys: 'N', // 没有支付系统权限(安卓)
                onlineChat: 'https://work.weixin.qq.com/kfid/kfc3ab9163b32d2aaba',
                weChat: 'https://work.weixin.qq.com/ca/cawcdeaca972858707',
            },
            'ks.bxsvip.com': {
                orderType: '44',
                disabledAndroid: false,
                hasPaySys: 'N', // 没有支付系统权限(安卓)
                onlineChat: 'https://work.weixin.qq.com/kfid/kfc4831009f3be0c1f0',
                weChat: 'https://work.weixin.qq.com/ca/cawcdedb56e3c42811',

            },
            
            'wap.ksmvp.cn/ks': {
                orderType: '46',
                disabledAndroid: false,
                hasPaySys: 'N', // 没有支付系统权限(安卓)
                onlineChat: 'https://work.weixin.qq.com/kfid/kfc3ab9163b32d2aaba',
                weChat: 'https://work.weixin.qq.com/ca/cawcdedb56e3c42811',

            },
            
        },
        BLACKLIST: [], // 快手抖音黑名单
    },
    mutations: {
        increment (state) {
            state.count++
        },
        updateTitle(state, data) {
            state.title = data;
        },
    }
})

export default store